// Utility to get current domain and generate appropriate URLs
export const getDomainUtils = () => {
  const primaryDomain = 'https://impelatek.fr';
  const secondaryDomain = 'https://impelatek.com';
  
  const getCurrentDomain = (): string => {
    if (typeof window !== 'undefined') {
      const currentHost = window.location.hostname;
      if (currentHost.includes('impelatek.com')) {
        return secondaryDomain;
      }
    }
    return primaryDomain;
  };
  
  const getAlternateLanguages = (path: string = '') => {
    return [
      { hrefLang: 'en', href: `${primaryDomain}${path}` },
      { hrefLang: 'en', href: `${secondaryDomain}${path}` },
      { hrefLang: 'fr', href: `${primaryDomain}${path}` },
      { hrefLang: 'fr', href: `${secondaryDomain}${path}` },
      { hrefLang: 'x-default', href: `${primaryDomain}${path}` }
    ];
  };
  
  const getCanonicalUrl = (path: string = '') => {
    // Always use primary domain for canonical
    return `${primaryDomain}${path}`;
  };
  
  const getCurrentUrl = (path: string = '') => {
    return `${getCurrentDomain()}${path}`;
  };
  
  const getImageUrl = (imagePath: string) => {
    return `${getCurrentDomain()}${imagePath}`;
  };
  
  return {
    getCurrentDomain,
    getAlternateLanguages,
    getCanonicalUrl,
    getCurrentUrl,
    getImageUrl,
    primaryDomain,
    secondaryDomain
  };
};

export default getDomainUtils;
